export default __webpack_public_path__ + "static/media/icon-img-1.dedec9a4.webp";